<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('assitive_device_management.recieve_against_purchase_order')}} {{ $t('globalTrans.entry') }}</h4>
          </template>
          <template v-slot:headerAction>
            <router-link to="recieve-against-purchase-order" :class="'btn btn-primary text-light'">{{  $t('assitive_device_management.recieve_against_purchase_order') }} {{ $t('globalTrans.list') }}</router-link>
          </template>
          <template v-slot:body>
            <b-row>
                <b-col xl="12" lg="12" sm="12">
                    <b-overlay :show="loading" rounded="sm">
                    <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                        <b-form @submit.prevent="handleSubmit(register)" @reset.prevent="reset">
                            <b-row>
                              <b-col lg="4" md="4" sm="4" xs="4">
                                <ValidationProvider name="Fiscal Year" vid="fiscal_year_id" rules="required|min_value:1">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="fiscal_year_id"
                                        slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                        {{$t('globalTrans.fiscal_year')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="data.fiscal_year_id"
                                    :options="fiscalYearList"
                                    id="fiscal_year_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                    </b-form-group>
                                </ValidationProvider>
                              </b-col>
                              <b-col lg="4" md="4" sm="4" xs="4">
                                <ValidationProvider name="PO No." vid="p_o_no" rules="required|min_value:1">
                                  <b-form-group
                                      class="row"
                                      label-cols-sm="4"
                                      label-for="p_o_no"
                                      slot-scope="{ valid, errors }"
                                  >
                                    <template v-slot:label>
                                      {{$t('assitive_device_management.p_o_no')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                        plain
                                        v-model="data.p_o_no"
                                        :options="purchaseList"
                                        id="p_o_no"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                      <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                      </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                      {{ errors[0] }}
                                    </div>
                                  </b-form-group>
                                </ValidationProvider>
                              </b-col>
                              <b-col lg="4" md="4" sm="4" xs="4">
                                  <ValidationProvider name="Chalan No" vid="challan_no" rules='required|min_value:1'>
                                      <b-form-group
                                          class="row"
                                          label-cols-sm="4"
                                          label-for="challan_no"
                                          slot-scope="{ valid, errors }"
                                      >
                                          <template v-slot:label>
                                              {{ $t('assitive_device_management.challan_no')}} <span class="text-danger">*</span>
                                          </template>
                                          <b-form-select
                                              plain
                                              v-model="data.challan_no"
                                              :options="challanNoListAll"
                                              id="challan_no"
                                              :state="errors[0] ? false : (valid ? true : null)"
                                              @change="getDeviceList(data.challan_no)"
                                          >
                                            <template v-slot:first>
                                              <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                          </b-form-select>
                                          <div class="invalid-feedback">
                                              {{ errors[0] }}
                                          </div>
                                      </b-form-group>
                                  </ValidationProvider>
                              </b-col>
                            </b-row>
<!--                            <b-row class="mb-4 mt-2" style="border: 1px solid black;padding-top: 23px;padding-bottom: 27px;}">-->
                            <div class="table-responsive">
                            <table class="table table-bordered table-sm mb-4">
                                <thead style="background-color: #44B2D8;">
                                <tr>
                                    <th>{{$t('globalTrans.sl_no')}}</th>
                                    <th>{{ $t('assitive_device_management.assistive_device_name')}}</th>
                                    <th>{{ $t('assitive_device_management.delivered_quantity')}}</th>
                                    <th>{{ $t('assitive_device_management.previous_received_quantity')}}</th>
                                    <th>{{ $t('assitive_device_management.recieved_quantity')}}</th>
                                    <th width="25%">{{ $t('assitive_device_management.remarks')}}</th>
<!--                                    <th>{{$t('globalTrans.action')}}</th>-->
                                </tr>
                            </thead>
                            <tbody>
                              <template v-if="AddmoreArray.length">
                                <tr v-for="(itemm,index) in AddmoreArray" :key="index" >
                                    <td style="color:black;">{{$n(index + 1)}}</td>
                                    <td style="color:black;">
                                    {{ currentLocale === 'en' ? itemm.device_name_en : itemm.device_name_bn }}
                                    </td>
                                    <td style="color:black;">
                                      {{ $n(itemm.quantity) }}
                                    </td>
                                    <td style="color:black;">
                                      {{ $n(itemm.previous_received_quantity) }}
                                    </td>
                                    <td style="color:black;">
                                    <ValidationProvider name="Received Quantity" :vid="'devices.'+index+'.received_quantity'" :rules="(itemm.received_quantity ? 'required|numeric|max_value:'+(itemm.quantity - itemm.previous_received_quantity) : '')">
                                        <b-form-group
                                            :label-for="'devices.'+index+'.received_quantity'"
                                            slot-scope="{ valid, errors }"
                                        >
                                            <b-form-input
                                            :id="'devices.'+index+'.received_quantity'"
                                            v-model="itemm.received_quantity"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            @input="setReceivedQuantity(itemm)"
                                            @keypress="isNumber($event)"
                                            ></b-form-input>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                    </td>
                                    <td style="color:black;">
                                    <ValidationProvider name="Remarks" vid='quantity' rules="">
                                        <b-form-group
                                            label-for="quantity"
                                            slot-scope="{ valid, errors }"
                                        >
                                            <b-form-input
                                            id="quantity"
                                            v-model="itemm.remarks"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            ></b-form-input>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                    </td>
<!--                                    <td style="color:black;">-->
<!--                                    <b-button class="mr-1" title="View Details" v-b-modal.modal-detail variant=" iq-bg-success mr-1" size="sm" @click="PassData()"><i class="ri-eye-line m-0 "></i></b-button>-->
<!--                                    </td>-->
                                </tr>
                              </template>
                              <template v-else>
                                <tr>
                                  <td align="center" colspan="7">{{ $t('globalTrans.noDataFound') }}</td>
                                </tr>
                              </template>
                            </tbody>
                            </table>
                            </div>
<!--                            </b-row>-->
                            <b-row>
                              <b-col lg="6" md="6" sm="6" xs="6">
                                  <ValidationProvider name="Received Date" vid="received_date" rules="required">
                                      <b-form-group
                                          class="row"
                                          label-cols-sm="4"
                                          label-for="received_date"
                                          slot-scope="{ valid, errors }"
                                      >
                                      <template v-slot:label>
                                          {{$t('assitive_device_management.recieved_date')}} <span class="text-danger">*</span>
                                      </template>
                                      <flat-pickr class="form-control"
                                          v-model="data.received_date"
                                          id="to_date"
                                          :state="errors[0] ? false : (valid ? true : null)"
                                          >
                                      </flat-pickr>
                                        <div class="invalid-feedback" :class="(errors.length ? 'd-block' : '')">
                                          {{ errors[0] }}
                                        </div>
                                      </b-form-group>
                                  </ValidationProvider>
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col lg="6" md="6" sm="6" xs="6">
                                  <ValidationProvider name="Description (En)" vid="description_en">
                                      <b-form-group
                                          class="row"
                                          label-cols-sm="4"
                                          label-for="description_en"
                                          slot-scope="{ valid, errors }"
                                      >
                                      <template v-slot:label>
                                          {{$t('globalTrans.description_en')}}
                                      </template>
                                      <b-form-textarea
                                      id="description_en"
                                      v-model="data.description_en"
                                      :state="errors[0] ? false : (valid ? true : null)"
                                      ></b-form-textarea>
                                      <div class="invalid-feedback">
                                      {{ errors[0] }}
                                      </div>
                                      </b-form-group>
                                  </ValidationProvider>
                              </b-col>
                              <b-col lg="6" md="6" sm="6" xs="6">
                                <ValidationProvider name="Description (Bn)" vid="description_bn">
                                  <b-form-group
                                      class="row"
                                      label-cols-sm="4"
                                      label-for="description_bn"
                                      slot-scope="{ valid, errors }"
                                  >
                                    <template v-slot:label>
                                      {{$t('globalTrans.description_bn')}}
                                    </template>
                                    <b-form-textarea
                                        id="description_bn"
                                        v-model="data.description_bn"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-textarea>
                                    <div class="invalid-feedback">
                                      {{ errors[0] }}
                                    </div>
                                  </b-form-group>
                                </ValidationProvider>
                              </b-col>
                            </b-row>
                            <div class="row">
                            <div class="col-sm-3"></div>
                            <div class="col text-right">
                                <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                              <router-link to="recieve-against-purchase-order"><b-button variant="danger" class="mr-1">{{ $t('globalTrans.cancel') }}</b-button></router-link>
                            </div>
                            </div>
                        </b-form>
                    </ValidationObserver>
                    </b-overlay>
                </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '../../../../../config/pluginInit'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { awarenessEventServiceBaseUrl } from '@/config/api_config'
import {
  RecieveAgainstPurchaseOrderStore,
  fundRecievedUpdate,
  chalanWiseAssistiveDeviceName,
  purchaseMemoList, distPurOrderChallanNoList, RecieveAgainstPurchaseOrderDeviceList
} from '../../api/routes'
import { helpers } from '@/mixins/helper-functions'

export default {
    name: 'FormLayout',
    props: ['id', 'item'],
    components: {
        ValidationObserver,
        ValidationProvider
    },
    created () {
      if (this.$store.state.dataFilters.officeId) {
        const centerOfficeId = this.$store.state.dataFilters.officeId
        this.activeCenter = this.idscCenterList.find(item => item.office_id === parseInt(centerOfficeId))
        this.data = Object.assign({}, this.data, {
          idsc_center_id: this.activeCenter.value
        })
      }
      this.getPurchaseMemoList()
      if (this.$route.query.item) {
          this.AddmoreArray.push(...this.$route.query.item.details)
        //   this.predata = this.getData()
        //   this.AddmoreArray.push(...this.$route.query.item.details)
          this.data.fiscal_year_id = this.$route.query.item.fiscal_year_id
          this.data.challan_no = this.$route.query.item.challan_no
          this.data.p_o_no = this.$route.query.item.p_o_no
          this.data.received_date = this.$route.query.item.received_date
          this.data.description = this.$route.query.item.description
      }
      this.data = Object.assign({}, this.data, {
        received_date: helpers.currentDate()
      })
    },
    mounted () {
        core.index()
    },
    data () {
        return {
            ItemShow: false,
            saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
            predata: null,
            loading: false,
            itemToget: {},
            data: {
                fiscal_year_id: 0,
                challan_no: 0,
                p_o_no: 0,
                received_date: '',
                description: '',
                devices: [],
                idsc_center_id: 0
            },
            validationArray: [],
            addmorelist:
             {
                assistive_device_id: '',
                delivered_quantity: '',
                recieved_quantity: '',
                unit_price: '',
                total_price: ''
            },
            AddmoreArray: [],
            AddmoreArrayProp: [],
            purchaseList: [],
            purchaseMemoListAll: [],
            challanNoListAll: [],
            challanNoList: [],
            isLoading: false,
            activeCenter: {
              value: 0
            }
        }
    },
    computed: {
      currentLocale () {
        return this.$i18n.locale
      },
      fiscalYearList: function () {
        return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
      },
      yearList () {
        return helpers.getYearList()
      },
      assistiveDeviceList: function () {
      return this.$store.state.AwarenessEventService.commonObj.assistiveDeviceList.filter(item => item.status === 1)
      },
      orgList: function () {
          return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
      },
      fiscalYear: function () {
          const objectData = this.$store.state.commonObj.fiscalYearList
          return objectData.map((obj, key) => {
              if (this.$i18n.locale === 'bn') {
                  return { value: obj.value, text: obj.text_bn }
              } else {
                  return { value: obj.value, text: obj.text_en }
              }
          })
      },
      idscCenterList: function () {
        return this.$store.state.AwarenessEventService.commonObj.idscCenterList.filter(item => item.status === 1)
      }
    },
    watch: {
      'data.organization': function (newVal) {
        this.officeTypeList = this.getofficeTypeList(newVal)
      },
      'data.institute_type': function (newVal) {
        this.officeList = this.getOfficeList(newVal)
      },
      'data.fiscal_year_id': function (newVal) {
        if (newVal) {
          this.purchaseList = this.getMemoList(newVal)
        } else {
          this.purchaseList = []
        }
      },
      'data.p_o_no': function (newVal) {
        if (newVal) {
          this.getChallanNoList(newVal)
        }
      }
    },
    methods: {
      PassData () {
        //   this.data.devices = this.AddmoreArray
        //   this.itemToget = this.data
      },
      unitPrice () {
           let totalPrice = 0
           totalPrice = this.addmorelist.recieved_quantity * this.addmorelist.unit_price
           if (!isNaN(totalPrice)) {
           this.addmorelist.total_price = totalPrice
           }
      },
      async getChalanWiseAssistiveDevice () {
          this.loading = true
          var result = await RestApi.getData(awarenessEventServiceBaseUrl, chalanWiseAssistiveDeviceName, this.data)
          this.AddmoreArray = []
          this.AddmoreArrayProp = []
          const PropArray = result.assistivelist
          this.AddmoreArrayProp.push(...PropArray)
          this.AddmoreArray.push(...result.assistivelist)
          this.data.p_o_no = result.data.purchase_memo_no
          this.itemToget = result.details
          this.loading = false
          },
        addItem () {
            const obj = {
                assistive_device_id: this.addmorelist.assistive_device_id,
                delivered_quantity: this.addmorelist.delivered_quantity,
                recieved_quantity: this.addmorelist.recieved_quantity,
                unit_price: this.addmorelist.unit_price,
                total_price: this.addmorelist.total_price
            }
            this.validationArray.push(obj)
            const validation = this.validationArray.every(item => item.assistive_device_id && item.delivered_quantity && item.recieved_quantity && item.unit_price && item.total_price)
            if (validation === false) {
            this.$toast.success({
                    title: 'Error',
                    message: 'Please Fill all three fields',
                    color: '#a61927'
            })
            this.validationArray = []
            } else {
            this.AddmoreArray.push(obj)
            this.addmorelist = []
            }
        },
        delItem (index) {
         this.AddmoreArray.splice(index, 1)
        },
        getofficeTypeList (orgId = null) {
            const instituteTypeList = this.$store.state.commonObj.officeTypeList.filter(item => item.status === 0)
            if (orgId) {
                return instituteTypeList.filter(institute => institute.org_id === orgId)
            }
            return instituteTypeList
        },
        getOfficeList (typeId = null) {
            const instituteList = this.$store.state.commonObj.officeList.filter(item => item.status === 0)
            if (typeId) {
                return instituteList.filter(institute => institute.office_type_id === typeId)
            }
            return instituteList
        },
        async register () {
            this.loading = true
            this.$store.dispatch('mutateCommonProperties', { loading: true })
            let result = null
            const loadinState = { loading: false, listReload: true }
            this.data.devices = []
            this.data.devices = this.AddmoreArray
            if (this.id) {
                var formData = new FormData()
                Object.keys(this.data).map(key => {
                  if (key === 'devices') {
                    formData.append('devices', JSON.stringify(this.data.devices))
                  } else {
                    formData.append(key, this.data[key])
                  }
                })
                formData.append('id', this.id)
                result = await RestApi.postData(awarenessEventServiceBaseUrl, fundRecievedUpdate, formData)
            } else {
                result = await RestApi.postData(awarenessEventServiceBaseUrl, RecieveAgainstPurchaseOrderStore, this.data)
            }
            this.$store.dispatch('mutateCommonProperties', loadinState)
            if (result.success) {
                this.data = {
                  fiscal_year_id: 0,
                  challan_no: '',
                  p_o_no: '',
                  received_date: '',
                  description_en: '',
                  description_bn: '',
                  devices: []
                }
                this.$nextTick(() => {
                  this.$refs.form.reset()
                })
                this.loading = false
                this.$store.dispatch('HospitalDisabilityService/mutateCommonObj', { hasDropdownLoaded: false })
                this.$toast.success({
                  title: this.$t('globalTrans.success'),
                  message: this.$t('globalTrans.save_msg'),
                  color: '#D6E09B'
                })
                this.$router.push('recieve-against-purchase-order')
            } else {
                if (result.errors) {
                  this.$refs.form.setErrors(result.errors)
                } else {
                  this.$toast.error({
                    title: this.$t('globalTrans.error'),
                    message: result.message
                  })
                }
                this.loading = false
            }
        },
        getData () {
            const tmpData = this.$store.state.list.find(item => item.id === parseInt(this.id))
            return JSON.parse(JSON.stringify(tmpData))
        },
      async getPurchaseMemoList () {
        this.loading = true
        const response = await RestApi.getData(awarenessEventServiceBaseUrl, purchaseMemoList)
        if (response.success) {
          this.purchaseMemoListAll = response.data.map(item => {
            const customItem = {
              value: item.value, text: this.$i18n.locale === 'bn' ? helpers.convertEnglishToBanglaNumber(item.text_bn) : item.text_en
            }
            return Object.assign({}, item, customItem)
          })
            this.data = Object.assign({}, this.data, {
                fiscal_year_id: this.$store.state.currentFiscalYearId
            })
        } else {
          this.purchaseMemoListAll = []
        }
        this.loading = false
      },
      getMemoList (fiscalYearId = null) {
        let purchaseMemoList = this.purchaseMemoListAll
        if (fiscalYearId) {
          purchaseMemoList = purchaseMemoList.filter(item => item.fiscal_year_id === parseInt(fiscalYearId))
        }
        return purchaseMemoList
      },
      async getChallanNoList (purchaseMemoNo = null) {
        this.loading = true
        const response = await RestApi.getData(awarenessEventServiceBaseUrl, `${distPurOrderChallanNoList}/${purchaseMemoNo}`, { idsc_center_id: this.data.idsc_center_id })
        if (response.success) {
          this.challanNoListAll = response.data.map(item => {
            // item.devices = item.devices.map(deviceItem => {
            //   const device = this.assistiveDeviceList.find(obj => obj.value === deviceItem.assistive_device_id)
            //   const deviceItemCustom = {
            //     device_name_en: device?.text_en,
            //     device_name_bn: device?.text_bn
            //   }
            //   return Object.assign({}, deviceItem, deviceItemCustom)
            // })
            // const idscCenter = this.idscCenterList.find(obj => obj.value === item.idsc_center_id)
            const customItem = {
              value: item.challan_no,
              text: this.$i18n.locale === 'bn' ? helpers.convertEnglishToBanglaNumber(item.challan_no) : item.challan_no
              // center_name_en: idscCenter?.text_en,
              // center_name_bn: idscCenter?.text_bn
            }
            return Object.assign({}, item, customItem)
          })
        } else {
          this.challanNoListAll = []
        }
        this.loading = false
      },
      async getDeviceList (challanNo) {
        this.loading = true
        const result = await RestApi.getData(awarenessEventServiceBaseUrl, RecieveAgainstPurchaseOrderDeviceList + '/' + challanNo)
        if (result.success) {
          this.AddmoreArray = this.getCustomizedDeviceList(result.data)
        } else {
          this.AddmoreArray = []
        }
        this.loading = false
      },
      getCustomizedDeviceList (data) {
        return data.map(deviceItem => {
          const device = this.assistiveDeviceList.find(obj => obj.value === deviceItem.assistive_device_id)
          const deviceItemCustom = {
            device_name_en: device?.text_en,
            device_name_bn: device?.text_bn,
            previous_received_quantity: deviceItem.received_quantity,
            received_quantity: 0,
            remarks: ''
          }
          return Object.assign({}, deviceItem, deviceItemCustom)
        })
      },
      isNumber: function (evt) {
        if (evt === 'undefined' || evt === null) {
          evt = window.event
        }
        var charCode = (evt.which) ? evt.which : evt.keyCode
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
          evt.preventDefault()
        } else {
          return true
        }
      },
      setReceivedQuantity (obj) {
        this.$nextTick(() => {
          const maxAssignedValue = obj.quantity - obj.previous_received_quantity
          if (obj.received_quantity > maxAssignedValue) {
            obj.received_quantity = maxAssignedValue
          }
        })
      }
    }
}
</script>

<style>
body {
  font-family: Arial, sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
}

table, th, td {
  border: solid 1px #000;
  padding: 10px;
  color: black;
}

table {
    border-collapse:collapse;
    caption-side:bottom;
}

caption {
  font-size: 16px;
  font-weight: bold;
  padding-top: 5px;
}
/*.toast-title {*/
/*  color:white;*/
/*}*/
/*.toast-message {*/
/*    color:white;*/
/*}*/
.is-valid {
        padding-right: 0px!important;
}
</style>
